import React from 'react';
import styled from 'styled-components';
import { Outlet, Link } from "react-router-dom";

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;

  li {
    padding: 18px 10px;
  }

  li:hover{
    background-color: #8bcdf3;
    color: white;
  }

  a:hover{
    background-color: #8bcdf3;
    color: white;
  }

  a {
    line-height: 35px;
    color : #000000;
    text-decoration : none;
    height : 50px;
    width: 100px;
    text-align : center;
  }

  @media (max-width: 768px) {
    flex-flow: column nowrap;
    background-color: #eeeeee;
    padding-left : 0px;
    position: fixed;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;

    li {
      color: #fff;
    }

    a {
      line-height : 25px;
      color : #000000;
      text-decoration : none;
      height : 50px;
      width: 300px;
      text-align : center;
      padding-top : 25px;
    }

  }

`;

const RightNav = ({ open }) => {
  return (
    <Ul open={open}>
      {/* <li> */}
          <Link to="/" onClick={()=>open(false)}>Home</Link>
      {/* </li> */}
      {/* <li> */}
          <Link to="/Login" onClick={() => open(false)}>Login</Link>
      {/* </li> */}
      {/* <li> */}
          <Link to="/ActivityList" onClick={() => open(false)}>Course</Link>
      {/* </li> */}
      {/* <li> */}
          <Link to="/CP" onClick={() => open(false)}>CPI Demo</Link>
      {/* </li> */}
    </Ul>
  )
}

export default RightNav
